import { createRouter, createWebHistory } from 'vue-router';
import ArticlesContent from '@/components/ArticlesContent';
import AlloysContent from '@/components/AlloysContent';
const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/:after(.*)?/legierungszuschlaege',
            alias: '/:after(.*)/alloy-surcharges',
            name: 'alloys',
            component: AlloysContent,
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'products',
            component: ArticlesContent,
        },
    ],
});
export default router;
